module.exports = __webpack_public_path__ + "img/svg2.be089356.svg";